import React from 'react';

const Tr = React.forwardRef(({ className = 'text-sm', children,  ...props }, ref) => (
  <tr ref={ref} style={{ height: '49.5px' }} className={className} {...props}>
    {children}
  </tr>
));

export default Tr;